import { VStack, Heading, Text } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { StackProps } from "@chakra-ui/react";
import type { SectionHeaderProps } from "./SectionHeader.d";

export const SectionHeader = ({
  preheader,
  header,
  id,
  dataTestId,
  spacing = 4,
  hAlignmentMobile = "start",
  hAlignmentTablet = "start",
  hAlignmentDesktop = "start",
  sbEditable,
  ...props
}: SbEditableComponentProps<SectionHeaderProps>) => {
  const alignItems = {
    base: hAlignmentMobile,
    md: hAlignmentTablet,
    lg: hAlignmentDesktop,
  } as StackProps["justify"];

  return (
    <VStack spacing={spacing} alignItems={alignItems} {...props} {...sbEditable}>
      {preheader && (
        <Text fontSize="xs" color="primary.500" textTransform="uppercase" fontWeight="bold" letterSpacing="1.5px">
          {preheader}
        </Text>
      )}
      <Heading variant="h2" as="h2" size="xl" id={id} data-testid={dataTestId}>
        {header}
      </Heading>
    </VStack>
  );
};
